/* =============================================
   ModelCarKings — Theme JavaScript
   ============================================= */

(function () {
  'use strict';

  /* ---- Utility -------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- Mobile Nav ----------------------------- */
  const mobileNav = qs('.mobile-nav');
  const mobileNavOpen = qs('.mobile-menu-btn');
  const mobileNavClose = qs('.mobile-nav__close');
  const mobileNavOverlay = qs('.mobile-nav__overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (mobileNavOpen) mobileNavOpen.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
    if (mobileNavOpen) mobileNavOpen.setAttribute('aria-expanded', 'false');
  }

  on(mobileNavOpen, 'click', openMobileNav);
  on(mobileNavClose, 'click', closeMobileNav);
  on(mobileNavOverlay, 'click', closeMobileNav);

  // Mobile nav accordion
  qsa('.mobile-nav__link[data-has-children]').forEach(function (link) {
    on(link, 'click', function (e) {
      e.preventDefault();
      const sublevel = link.nextElementSibling;
      if (sublevel) sublevel.classList.toggle('is-open');
    });
  });

  /* ---- Search Drawer -------------------------- */
  const searchDrawer = qs('.search-drawer');
  const searchBtns = qsa('.search-open-btn');
  const searchClose = qs('.search-drawer__close');
  const searchInput = qs('.search-drawer__input');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('is-open');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
  }

  searchBtns.forEach(function (btn) { on(btn, 'click', openSearch); });
  on(searchClose, 'click', closeSearch);

  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeCartDrawer(); closeMobileNav(); }
  });

  // Predictive search
  let searchTimer;
  on(searchInput, 'input', function () {
    clearTimeout(searchTimer);
    const val = searchInput.value.trim();
    if (val.length < 2) { clearSearchResults(); return; }
    searchTimer = setTimeout(function () { doSearch(val); }, 300);
  });

  on(searchInput, 'keydown', function (e) {
    if (e.key !== 'Enter') return;
    var q = searchInput.value.trim();
    if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
  });

  function doSearch(query) {
    const resultsEl = qs('.search-drawer__results');
    if (!resultsEl) return;
    resultsEl.innerHTML = '<div style="padding:1rem;text-align:center"><div class="loading-spinner"></div></div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          resultsEl.innerHTML = '<p style="padding:1rem;color:var(--color-text-muted);font-size:0.875rem">No results found for "' + query + '"</p>';
          return;
        }
        var searchUrl = '/search?q=' + encodeURIComponent(query) + '&type=product';
        resultsEl.innerHTML =
          products.map(function (p) {
            const img = p.featured_image ? '<img class="search-result-item__img" src="' + p.featured_image.url + '" alt="' + (p.featured_image.alt || p.title) + '" loading="lazy">' : '<div class="search-result-item__img"></div>';
            return '<a href="' + p.url + '" class="search-result-item">' +
              img +
              '<div><div class="search-result-item__title">' + p.title + '</div>' +
              '<div class="search-result-item__meta">' + (p.vendor || '') + ' &nbsp;&bull;&nbsp; ' + formatMoney(p.price) + '</div></div></a>';
          }).join('') +
          '<a href="' + searchUrl + '" class="search-results-footer">See all results for &ldquo;' + query + '&rdquo; &rarr;</a>';

        // ↑/↓ keyboard navigation through results
        resultsEl._query = query;
      })
      .catch(function () { clearSearchResults(); });
  }

  // Keyboard navigation: ↑↓ moves focus through result items, Enter follows link
  on(searchInput, 'keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    e.preventDefault();
    var items = qsa('.search-result-item', qs('.search-drawer__results'));
    if (!items.length) return;
    var focused = document.activeElement;
    var idx = items.indexOf(focused);
    if (e.key === 'ArrowDown') idx = idx < items.length - 1 ? idx + 1 : 0;
    else idx = idx > 0 ? idx - 1 : items.length - 1;
    items[idx].focus();
  });

  function clearSearchResults() {
    const resultsEl = qs('.search-drawer__results');
    if (resultsEl) resultsEl.innerHTML = '';
  }

  /* ---- Cart Drawer ---------------------------- */
  const cartDrawer = qs('.cart-drawer');
  const cartOverlay = qs('.cart-drawer__overlay');
  const cartOpenBtns = qsa('.cart-open-btn');
  const cartClose = qs('.cart-drawer__close');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartOpenBtns.forEach(function (btn) { on(btn, 'click', openCartDrawer); });
  on(cartClose, 'click', closeCartDrawer);
  on(cartOverlay, 'click', closeCartDrawer);

  function refreshCart() {
    (function fetchCartState(n) {
      fetch('/cart.js')
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(cart) { try { renderCart(cart); popCartBadge(); } catch(e) {} })
        .catch(function() { if (n > 0) setTimeout(function() { fetchCartState(n - 1); }, 600); });
    }(3));
  }

  function renderCart(cart) {
    const body = qs('.cart-drawer__body');
    const subtotalEl = qs('.cart-subtotal__amount');
    const countEl = qs('.cart-count');
    const thresholdCents = (window.MCK_FREE_SHIPPING_THRESHOLD || 75) * 100;

    if (countEl) {
      var prevCount = parseInt(countEl.textContent) || 0;
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      if (cart.item_count > prevCount) popCartBadge();
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Show / hide "Clear all" button
    var clearBtn = document.getElementById('cart-clear-btn');
    if (clearBtn) clearBtn.style.display = cart.item_count > 0 ? '' : 'none';

    const collectorSceneProductIds = new Set(["15149022118254","15149022151022","15149022216558","15149022282094","15149022347630","15149022445934","15149022740846","15149022773614","15149022871918","15149022904686"]);
    const hasScene = cart.items.some(function(item) {
      const sceneText = [item.product_title, item.title, item.product_type, item.handle].filter(Boolean).join(' ');
      return collectorSceneProductIds.has(String(item.product_id)) || /\bdiorama\b|\bscene\b/i.test(sceneText);
    });
    const hasPreorderScene = hasScene && cart.items.some(function(item) {
      return /pre[- ]?order/i.test([item.product_title, item.title].filter(Boolean).join(' '));
    });
    if (cartDrawer) cartDrawer.classList.toggle('has-mck-collector-scenes', hasScene);

    const freeShippingBlock = qs('.cart-free-shipping');
    const drawerSceneNote = qs('.mck-cart-drawer-note');
    if (freeShippingBlock) freeShippingBlock.style.display = hasScene ? 'none' : '';
    if (drawerSceneNote && hasScene) {
      drawerSceneNote.textContent = hasPreorderScene
        ? 'Pre-order scene shipping is confirmed after production and final packing details are checked.'
        : 'Available scenes: $29.99 worldwide under $150. Shipping is free from $150 and confirmed at checkout.';
    }

    const freeBar = qs('.cart-free-shipping__fill');
    const freeText = qs('.cart-free-shipping__text');
    if (freeBar && thresholdCents > 0 && !hasScene) {
      const pct = Math.min(100, Math.round((cart.total_price / thresholdCents) * 100));
      freeBar.style.width = pct + '%';
      if (freeText) {
        freeText.textContent = cart.total_price >= thresholdCents
          ? 'Free U.S. shipping unlocked for eligible diecast cars and display accessories.'
          : formatMoney(thresholdCents - cart.total_price) + ' away from free U.S. shipping on eligible diecast cars and display accessories.';
      }
    }

    if (!body) return;

    if (cart.item_count === 0) {
      // Auto-close drawer when it's emptied by a removal so overlay doesn't block the page
      var drawerEl = qs('.cart-drawer');
      var wasOpen  = drawerEl && drawerEl.classList.contains('is-open');
      body.innerHTML = '<div class="cart-drawer__empty">' +
        '<svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/></svg>' +
        '<p>Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn-primary btn-sm">Shop Now</a>' +
        '</div>';
      if (wasOpen) setTimeout(function() { closeCartDrawer(); }, 800);
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      const img = item.image ? '<img class="cart-item__img" src="' + item.image + '" alt="' + item.title + '" loading="lazy">' : '<div class="cart-item__img"></div>';
      const selectedVersion = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : 'Standard option';
      const selectedMeta = '<div class="mck-cart-item-meta">' +
        '<span><b>Selected</b> ' + selectedVersion + '</span>' +
        '</div>';
      return '<div class="cart-item" data-key="' + item.key + '">' +
        img +
        '<div class="cart-item__details">' +
          '<div class="cart-item__title">' + item.product_title + '</div>' +
          selectedMeta +
          '<div class="cart-item__price-row">' +
            '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-action="decrease">&#8722;</button>' +
              '<span class="cart-item__qty-val">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-action="increase">&#43;</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    // Bind qty buttons — disable immediately for feedback, re-enabled after renderCart
    qsa('.cart-item__qty-btn', body).forEach(function (btn) {
      on(btn, 'click', function () {
        const item = btn.closest('.cart-item');
        const key = item.dataset.key;
        const valEl = qs('.cart-item__qty-val', item);
        const current = parseInt(valEl.textContent);
        const newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        // Optimistic UI: update count immediately + lock all buttons
        valEl.textContent = newQty > 0 ? newQty : 0;
        qsa('.cart-item__qty-btn, .cart-item__remove', body).forEach(function (b) { b.disabled = true; b.style.opacity = '0.4'; });
        updateCartItem(key, newQty);
      });
    });

    qsa('.cart-item__remove', body).forEach(function (btn) {
      on(btn, 'click', function () {
        btn.disabled = true; btn.style.opacity = '0.4';
        qsa('.cart-item__qty-btn', body).forEach(function (b) { b.disabled = true; b.style.opacity = '0.4'; });
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        // Re-enable buttons and alert user
        qsa('.cart-item__qty-btn, .cart-item__remove').forEach(function (b) { b.disabled = false; b.style.opacity = ''; });
        showToast('Could not update cart. Please try again.', 'error');
      });
  }

  function clearCart() {
    var btn = document.getElementById('cart-clear-btn');
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Clear all'; }
        showToast('Could not clear cart. Please try again.', 'error');
      });
  }

  on(document, 'click', function(e) {
    if (e.target.id === 'cart-clear-btn' && !e.target.disabled) clearCart();
  });


  /* ---- Add-to-cart fly animation -------------- */
  function flyToCart(sourceEl) {
    var cartBtn = qs('.cart-open-btn');
    if (!cartBtn) return;

    // Find product image: gallery main image or product-card image
    var img = null;
    var gallery = sourceEl && sourceEl.closest('.product-gallery, .product-info');
    if (gallery) img = qs('.product-gallery__main img, .product-gallery img', gallery || document);
    if (!img) img = sourceEl && sourceEl.closest('.product-card') && qs('img', sourceEl.closest('.product-card'));

    var fly = document.createElement(img ? 'img' : 'div');
    if (img) fly.src = img.currentSrc || img.src;
    fly.className = 'atc-fly';
    fly.style.background = '#1a1a1a';

    // Start position: center of source element
    var src = (sourceEl || document.body).getBoundingClientRect();
    fly.style.left = (src.left + src.width  / 2 - 32) + 'px';
    fly.style.top  = (src.top  + src.height / 2 - 32) + 'px';
    document.body.appendChild(fly);

    // Trigger reflow, then animate to cart icon
    fly.getBoundingClientRect();
    var dst = cartBtn.getBoundingClientRect();
    fly.classList.add('is-landing');
    fly.style.left = (dst.left + dst.width  / 2 - 7) + 'px';
    fly.style.top  = (dst.top  + dst.height / 2 - 7) + 'px';

    fly.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'opacity') return;
      fly.removeEventListener('transitionend', onEnd);
      fly.remove();
      // Bump cart icon
      var svg = cartBtn.querySelector('svg');
      if (svg) {
        svg.classList.remove('cart-icon-bump');
        void svg.offsetWidth;
        svg.classList.add('cart-icon-bump');
        svg.addEventListener('animationend', function() { svg.classList.remove('cart-icon-bump'); }, { once: true });
      }
    });
  }

  function popCartBadge() {
    var badge = qs('.cart-count');
    if (!badge) return;
    badge.classList.remove('cart-count-pop');
    void badge.offsetWidth;
    badge.classList.add('cart-count-pop');
    badge.addEventListener('animationend', function() { badge.classList.remove('cart-count-pop'); }, { once: true });
  }

  /* ---- Add to Cart ----------------------------- */
  // Block click-based ATC handlers in competing Shopify scripts.
  // stopImmediatePropagation on window capture stops any click listener registered later.
  // We re-dispatch a fresh submit event so our submit handler still fires.
  window.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.product-atc-form [type="submit"]');
    if (!btn || btn.disabled) return; // ignore clicks while already processing
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = btn.closest('.product-atc-form');
    if (form) form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}));
  }, true);

  window.addEventListener('submit', function (e) {
    const form = e.target.closest('.product-atc-form');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // stop other scripts from also POSTing to /cart/add.js

    const btn = qs('[type="submit"]', form);
    if (!btn || btn.disabled) return; // already processing — ignore re-entrant submit
    const originalText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="loading-spinner"></span>';

    const data = new FormData(form);

    function doCartAdd(formData, attempt) {
      return fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) {
          if (r.ok) return r.json();
          if (r.status === 403 && attempt < 2) {
            // Transient cart lock — retry once after a short delay
            return new Promise(function(resolve) { setTimeout(resolve, 700); })
              .then(function() { return doCartAdd(new FormData(form), attempt + 1); });
          }
          return r.text().then(function(body) {
            var msg = 'Unable to add to cart. Please try again.';
            try {
              var err = JSON.parse(body);
              var raw = ((err.description || err.message) + '').toLowerCase();
              if (r.status === 403) {
                msg = 'Session expired — please refresh the page and try again.';
              } else if (raw.indexOf('stock') !== -1 || raw.indexOf('available') !== -1 || raw.indexOf('quantity') !== -1) {
                msg = 'This item is currently out of stock.';
              } else if (raw.indexOf('variant') !== -1 || raw.indexOf('find') !== -1) {
                msg = 'Please select a valid product option and try again.';
              } else if (raw.indexOf('already') !== -1 || raw.indexOf('maximum') !== -1) {
                msg = 'Maximum quantity already in your cart.';
              } else if (raw.indexOf('limit') !== -1) {
                msg = 'Cart limit reached for this item.';
              }
            } catch(_) {
              if (r.status === 403) msg = 'Session expired — please refresh the page and try again.';
            }
            throw new Error(msg);
          });
        });
    }

    doCartAdd(data, 1)
      .then(function () {
        // Add confirmed — reset button and show success immediately.
        // Cart state fetch is best-effort; failure here must NOT show an error.
        btn.innerHTML = '&#10003; Added!';
        btn.classList.add('is-success');
        flyToCart(btn);

        // Non-fatal cart state refresh — retry up to 3 times (Shopify cart lock clears quickly)
        (function fetchCartState(n) {
          fetch('/cart.js')
            .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
            .then(function(cart) {
              try { renderCart(cart); popCartBadge(); } catch(e) {}
            })
            .catch(function() {
              if (n > 0) { setTimeout(function() { fetchCartState(n - 1); }, 600); }
              else {
                // All retries exhausted — optimistically bump badge count
                var badge = qs('.cart-count');
                if (badge) {
                  badge.textContent = (parseInt(badge.textContent) || 0) + 1;
                  badge.style.display = 'flex';
                  popCartBadge();
                }
              }
            });
        }(3));

        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = originalText;
          btn.classList.remove('is-success');
          var t = showToast('Added to cart — tap to view →', 'success', 5000);
          if (t) {
            t.style.cursor = 'pointer';
            t.addEventListener('click', function(ev) {
              if (!ev.target.closest('.mck-toast__close') && window.openCartDrawer) window.openCartDrawer();
            });
          }
        }, 800); // brief "Added!" display before restoring button
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = originalText;
        btn.classList.remove('is-success');
        showToast((err && err.message) ? err.message : 'Unable to add to cart. Please try again.', 'error', 6000);
      });
  }, true);

  /* ---- Toast (MCKToast stacking system) -------- */
  var _mckToastStack = null;
  var _mckToasts = [];

  var _TOAST_ICONS = {
    success: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#22c55e" fill-opacity=".15"/><circle cx="12" cy="12" r="10" stroke="#22c55e" stroke-width="1.5"/><path d="M7.5 12.5l3 3 5.5-5.5" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    error:   '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#D72638" fill-opacity=".15"/><circle cx="12" cy="12" r="10" stroke="#D72638" stroke-width="1.5"/><path d="M8.5 8.5l7 7M15.5 8.5l-7 7" stroke="#D72638" stroke-width="2" stroke-linecap="round"/></svg>',
    info:    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="#60a5fa" fill-opacity=".15"/><circle cx="12" cy="12" r="10" stroke="#60a5fa" stroke-width="1.5"/><path d="M12 8v5m0 3h.01" stroke="#60a5fa" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function _getToastStack() {
    if (!_mckToastStack) {
      _mckToastStack = document.createElement('div');
      _mckToastStack.id = 'mck-toast-stack';
      document.body.appendChild(_mckToastStack);
    }
    return _mckToastStack;
  }

  function _dismissToast(el) {
    if (!el || el._dismissed) return;
    el._dismissed = true;
    clearTimeout(el._timer);
    el.classList.remove('is-visible');
    el.classList.add('is-hiding');
    setTimeout(function() {
      if (el.parentNode) el.parentNode.removeChild(el);
      _mckToasts = _mckToasts.filter(function(t) { return t !== el; });
    }, 350);
  }

  function showToast(msg, type, duration) {
    type     = type     || 'success';
    duration = duration || 4000;
    var iconKey = (type === 'error') ? 'error' : (type === 'info') ? 'info' : 'success';

    // Evict oldest if stacked ≥ 3
    while (_mckToasts.length >= 3) _dismissToast(_mckToasts[0]);

    var el = document.createElement('div');
    el.className = 'mck-toast mck-toast--' + type;
    el.innerHTML =
      '<div class="mck-toast__body">' +
        '<span class="mck-toast__icon">' + (_TOAST_ICONS[iconKey] || _TOAST_ICONS.success) + '</span>' +
        '<span class="mck-toast__msg">' + msg + '</span>' +
        '<button class="mck-toast__close" aria-label="Dismiss">&#x2715;</button>' +
      '</div>' +
      '<div class="mck-toast__bar"><div class="mck-toast__bar-fill"></div></div>';

    _getToastStack().appendChild(el);
    _mckToasts.push(el);

    // Animate in (double rAF ensures transition fires)
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        el.classList.add('is-visible');
        // Drain progress bar
        var fill = el.querySelector('.mck-toast__bar-fill');
        if (fill) {
          fill.style.transition = 'transform ' + duration + 'ms linear';
          fill.style.transform = 'scaleX(0)';
        }
      });
    });

    var closeBtn = el.querySelector('.mck-toast__close');
    if (closeBtn) closeBtn.addEventListener('click', function(ev) { ev.stopPropagation(); _dismissToast(el); });
    el._timer = setTimeout(function() { _dismissToast(el); }, duration);
    return el;
  }

  /* ---- Accordion ------------------------------- */
  on(document, 'click', function (e) {
    const trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    const item = trigger.closest('.accordion__item');
    if (item) item.classList.toggle('is-open');
  });

  /* ---- Gallery Thumbnails ---------------------- */
  on(document, 'click', function (e) {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const gallery = thumb.closest('.product-gallery');
    const mainImg = qs('.product-gallery__main img', gallery);
    if (mainImg) {
      mainImg.src = thumb.dataset.src || qs('img', thumb).src;
      mainImg.srcset = thumb.dataset.srcset || '';
    }
    qsa('.product-gallery__thumb', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  // Product image lightbox — click main image to view fullscreen
  on(document, 'click', function (e) {
    var img = e.target.closest('.product-gallery__main img');
    if (!img) return;
    var src = (img.srcset || '').split(',').reduce(function(best, part) {
      var m = part.trim().split(/\s+/);
      var w = parseInt((m[1] || '0').replace('w',''), 10);
      return w > best.w ? { url: m[0], w: w } : best;
    }, { url: img.src, w: 0 }).url;

    var overlay = document.createElement('div');
    overlay.className = 'img-lightbox';
    overlay.innerHTML =
      '<div class="img-lightbox__inner">' +
        '<img src="' + src + '" alt="' + (img.alt || '').replace(/"/g, '&quot;') + '">' +
        '<button class="img-lightbox__close" aria-label="Close">&#x2715;</button>' +
      '</div>';
    document.body.appendChild(overlay);
    requestAnimationFrame(function() { overlay.classList.add('is-open'); });

    function closeLightbox() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 280);
    }
    overlay.querySelector('.img-lightbox__close').addEventListener('click', closeLightbox);
    overlay.addEventListener('click', function(ev) { if (ev.target === overlay) closeLightbox(); });
    document.addEventListener('keydown', function onKey(ev) {
      if (ev.key === 'Escape') { closeLightbox(); document.removeEventListener('keydown', onKey); }
    });
  });

  /* ---- Filters (mobile toggle) ----------------- */
  const filterToggle = qs('.filter-toggle-btn');
  const filtersPanel = qs('.filters-panel');
  const filterClose = qs('.filters-close-btn');

  on(filterToggle, 'click', function () {
    if (filtersPanel) filtersPanel.classList.add('is-open');
  });
  on(filterClose, 'click', function () {
    if (filtersPanel) filtersPanel.classList.remove('is-open');
  });

  // Default: all filter groups open
  qsa('.filter-group').forEach(function(g) { g.classList.add('is-open'); });

  /* ---- Quantity Selectors ---------------------- */
  on(document, 'click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const wrap = btn.closest('.qty-selector');
    const input = qs('.qty-input', wrap);
    if (!input) return;
    const current = parseInt(input.value) || 1;
    if (btn.dataset.action === 'minus') input.value = Math.max(1, current - 1);
    if (btn.dataset.action === 'plus') input.value = current + 1;
  });

  /* ---- Variant selector ----------------------- */
  on(document, 'click', function (e) {
    const opt = e.target.closest('.variant-option');
    if (!opt) return;
    const group = opt.closest('.variant-options');
    if (group) qsa('.variant-option', group).forEach(function (o) { o.classList.remove('is-active'); });
    opt.classList.add('is-active');
    // Update hidden input
    const form = opt.closest('form');
    const input = form && qs('[name="id"]', form);
    if (input && opt.dataset.variantId) input.value = opt.dataset.variantId;

    // Update price display
    var priceEl = document.getElementById('product-price');
    var compareEl = document.getElementById('product-compare-price');
    var atcBtn = form && qs('.product-atc', form);
    if (priceEl && opt.dataset.price) {
      priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10));
    }
    if (compareEl && opt.dataset.comparePrice !== undefined) {
      var cap = parseInt(opt.dataset.comparePrice || 0, 10);
      var price = parseInt(opt.dataset.price || 0, 10);
      if (cap > price) {
        compareEl.textContent = formatMoney(cap);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    // Update Add to Cart button state
    var available = opt.dataset.available !== 'false';
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  });

  /* ---- Quick Add (product cards) --------------- */
  window.MCKQuickAdd = function(variantId, btn) {
    if (btn && btn.disabled) return;
    if (btn) {
      btn.disabled = true;
      btn._origHtml = btn.innerHTML;
      btn.innerHTML = '<span class="loading-spinner"></span>';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.ok ? r.json() : r.text().then(function(t) { throw new Error(t); }); })
    .then(function() {
      if (btn) {
        btn.innerHTML = '&#10003;';
        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = btn._origHtml || 'Add to Cart';
        }, 1600);
      }
      var t = showToast('Added to cart — tap to view →', 'success', 5000);
      if (t) {
        t.style.cursor = 'pointer';
        t.addEventListener('click', function(ev) {
          if (!ev.target.closest('.mck-toast__close') && window.openCartDrawer) window.openCartDrawer();
        });
      }
      (function fetchCartState(n) {
        fetch('/cart.js')
          .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
          .then(function(cart) { try { renderCart(cart); popCartBadge(); } catch(e) {} })
          .catch(function() { if (n > 0) setTimeout(function() { fetchCartState(n - 1); }, 600); });
      }(3));
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.innerHTML = btn._origHtml || 'Add to Cart'; }
      showToast('Could not add to cart. Please try again.', 'error');
    });
  };

  /* ---- Back to top ----------------------------- */
  (function () {
    var btn = document.createElement('button');
    btn.className = 'back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="18 15 12 9 6 15"/></svg>';
    document.body.appendChild(btn);
    var visible = false;
    window.addEventListener('scroll', function() {
      var should = window.scrollY > 400;
      if (should === visible) return;
      visible = should;
      btn.classList.toggle('is-visible', should);
    }, { passive: true });
    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }());

  /* ---- Init on load --------------------------- */
  window.MCK_FREE_SHIPPING_THRESHOLD = 75;
  window.refreshCart = refreshCart;
  window.showToast   = showToast;
  window.MCKToast    = { show: showToast };
  refreshCart();

}());

/* MCK cart item title fallback 2026-08-12 */
(function(){
  function restoreCartTitles(){
    if(location.pathname!='/cart')return;
    document.querySelectorAll('#cart-page-form .mck-cart-page-item').forEach(function(card){
      var title=card.querySelector('.cart-item__title');
      var image=card.querySelector('.cart-item__img');
      if(!title||title.textContent.trim()||!image)return;
      var text=(image.getAttribute('alt')||'').trim();
      var split=text.lastIndexOf(' - ');
      if(split>0)text=text.slice(0,split).trim();
      if(text)title.textContent=text;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restoreCartTitles);
  else restoreCartTitles();
})();

/* MCK diecast filtered collection heading 2026-08-12 */
(function(){
  function refineDiecastCollectionHeading(){
    if(location.pathname.replace(/\/$/,'')!='/collections/all/category-diecast-cars')return;
    var header=document.querySelector('.mck-collection-page .collection-header');
    if(!header)return;
    var title=header.querySelector('.mck-collection-title');
    var crumb=header.querySelector('[aria-current="page"]');
    var lede=header.querySelector('.mck-collection-lede');
    if(title)title.textContent='Diecast Model Cars';
    if(crumb)crumb.textContent='Diecast Model Cars';
    if(lede)lede.textContent='Collector models across 1:18, 1:24, 1:43 and 1:64 scale.';
    document.title='Diecast Model Cars | ModelCarKings';
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refineDiecastCollectionHeading);
  else refineDiecastCollectionHeading();
})();

/* MCK canonical diecast nav route 2026-08-12 */
(function(){
  function pointDiecastNavigation(){
    document.querySelectorAll('a[href="/collections/all/category-diecast-cars"]').forEach(function(link){link.setAttribute('href','/collections/diecast-model-cars')});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',pointDiecastNavigation);
  else pointDiecastNavigation();
})();
